
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
import { newList } from "@/apis/home";
@Component({
  components: {}
})
export default class Course extends Vue {
  @Prop({ required: true }) private list!: any;
  @Prop({ required: true }) private blmCourseList!: any;
  @Prop({ required: true }) private courseType!: any;
  formatUpyunUrl = formatUpyunUrl;
  infoList = [];
  caseList = [];
  // 点击切换
  handleBtn(key: any) {
    this.$emit("changeCourse", key);
  }
  // 点击更多
  handleMore(index: any) {
    if (index == 1) {
      this.$router.push(`/news`);
    } else if (index == 2) {
      this.$router.push(`/case`);
    }
  }

  created() {
    this.getList();
    this.getCaseList();
  }

  async getList() {
    const { data } = await newList({
      action: "list",
      classid: 36,
      page: 1,
      per_page: 2
    });
    this.infoList = data || [];
  }

  async getCaseList() {
    const { data } = await newList({
      action: "list",
      type: 1,
      page: 1,
      per_page: 2
    });
    this.caseList = data || [];
  }
  ///news-detail?id=60381&page=1
  toDetail1(item: any) {
    this.$router.push(`/news-detail?id=${item.id}&page=1`);
  }

  toDetail2(item: any) {
    this.$router.push(`case-detail?id=${item.case_id}&page=1`);
  }
}
